<template>
    <div :class="['form-auto-complete',{'focus': focus},{'error': !dataValid},{'disabled': disabled}]"
       @mouseover="hover = true"
       @mouseleave="hover = false">
      <div :class="['input-label',{'active': inputValue}]" @click="focused()" v-html="label"></div>
      <input :type="type"
             ref="input"
             @input="input()"
             @focus="focused()"
             @blur="blur()"
               :tabindex="disabled ? -1 : tabindex"
             v-model="inputValue" />
      <p v-show="!dataValid" class="error-text">{{dataError}}</p>
      <div v-show="listShow" @scroll="scrollList($event)" ref="list" class="list">
          <div v-for="(item, key) in showItems"
               :key="key"
               @click="select(item)"
               :class="['item', {'hover': key === position}]">
              {{item.text}}
          </div>
      </div>
  </div>
</template>

<script>

  export default {
        name: "buyer-select",
      data() {
          return {
              inputValue: "",
              focus: false,
              dataValid: true,
              dataError: "",
              listShow: false,
              list: [],
              hover: false,
              startValid: false,
              position: 0,
              tabPressed: false
          }
      },
      props: {
          type: {
              type: String,
              default: "text"
          },
          value: {
              type: [String, Number],
              default: ""
          },
          label: {
              type: String,
              default: "label"
          },
          valid: {
              type: Boolean,
              default: true
          },
          selectMode: {
              type: Boolean,
              default: false
          },
          error: {
              type: String,
              default: ""
          },
          items: {
              type: Array,
              default: () => []
          },
          parentFocus: {
              type: Boolean,
              default: false
          },
          loadItems: {
              type: Boolean,
              default: false
          },
          tabindex: {
              type: Number
            },
            disabled: {
                type: Boolean,
                default: false
          }
      },
      mounted() {
          window.addEventListener("keydown", this.keyDown);

          this.list = JSON.parse(JSON.stringify(this.items));

          if (this.value || this.value === 0) {
              const item = this.list.find(x => x.value === this.value);
              this.inputValue = item ? item.text : "";
          }
          this.dataValid = this.valid;
          this.dataError = this.localizeList[this.error];
      },
      computed: {
          showItems() {
              return this.list.filter(x => x.isShow)
          }
      },
      methods: {
          keyDown(e) {
              if (this.listShow) {

                  if (e.keyCode === 9) {
                      this.tabPressed = true;
                  }

                  if (e.keyCode === 38) {
                      if (this.position > 0) this.position--;
                  } else if (e.keyCode === 40) {
                      if (this.position < this.showItems.length-1) this.position++;
                  }
                  const itemHeight = this.$refs.list.children[0]?.scrollHeight || 0;
                  const scrollTo = this.position * itemHeight;
                  this.$refs.list.scrollTo({
                      top: scrollTo,
                      behavior: "smooth"
                  });

                  if (e.keyCode === 13) {
                      const item = this.showItems[this.position];
                      this.select(item)
                  }
              }
          },
          scrollList(e) {
              const currentScroll = e.target.scrollTop;
              const listHeight = e.target.scrollHeight;
              const listClientHeight = e.target.clientHeight;
              if (currentScroll >= listHeight - listClientHeight - 20 && this.loadItems) {
                  this.$emit("loadMoreItems")
              }
          },
          input() {
              this.position = 0;
              this.listShow = true
          },
          focused() {
              this.focus = true
              this.$refs.input.focus();
          },
          blur() {
              setTimeout(() => {
                  let includes = this.list.some(x => x.text === this.inputValue);
                  this.inputValue = includes ? this.inputValue : "";
              }, 500);

              this.focus = false;
          },
          select(item) {
              this.inputValue = item.text;
              this.$emit("input", item.value);
              this.$emit("change", item.value);
              this.cashSelectedItem = item;
              this.listShow = false;
              this.position = 0;
          }
      },
      watch: {
          items: {
              deep: true,
              handler(val) {
                  this.list = JSON.parse(JSON.stringify(val));
                  if (this.value || this.value === 0) {
                      const item = this.list.find(x => x.value === this.value);
                      this.inputValue = item ? item.text : "";
                  }
              }
          },
          value(val) {
              const item = this.list.find(x => x.value === val);
              this.inputValue = item ? item.text : "";
          },
          inputValue(val, oldVal) {
              if (this.selectMode) {
                  if (!val.length && oldVal.length) {
                      this.inputValue = oldVal
                  }
                  if (val.length > 1) {
                        this.inputValue = val
                  }
              } else {
                  if (val && val.length) {
                      this.list = this.list.map(x => {
                          x.isShow = x.text.toLowerCase().indexOf(val.toLowerCase()) !== -1;
                          return x
                      });
                      this.dataValid = true;
                  } else {
                      this.list = this.list.map(x => {
                          x.isShow = true;
                          return x
                      });
                      this.$emit("input", "");
                      if (this.startValid) {
                          this.dataError = this.error;
                          this.dataValid = false;
                      }
                  }
              }
          },
          valid(val) {
              this.dataValid = val;
              this.startValid = true;
          },
          error(val) {
              this.dataError = this.localizeList[val]
          },
          focus(val) {
              if (!val) {
                  if (!this.hover || this.tabPressed) {
                      this.listShow = false;
                      this.tabPressed = false
                  }
                  this.$emit("blur", true);
              } else {
                  this.listShow = true;
                  this.$emit("focus", true);
              }
          },
          localizeList(val) {
              this.dataError = val[this.error];
          },
          parentFocus(val){
              if (val){
                  this.focused();
              }
          }
      },
      beforeDestroy() {
          window.removeEventListener("keydown", this.keyDown);
      }
  }
</script>

<style scoped>
    .disabled {
        pointer-events: none;
    }
  .form-auto-complete {
      position: relative;
  }
  .form-auto-complete input {
      width: 100%;
      outline: none;
      border: none;
      border-bottom: 1px solid #aaa;
      padding: 5px 0;
      margin-top: 20px;
      font-weight: 500;
      font-size: 15px;
      color: #1D1D1D;
      box-shadow: inset 0 0 0 50px var(--white-color);
  }
  .error.form-auto-complete input {
      border-bottom: 1px solid red;
  }
  .form-auto-complete:before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      width: 0;
      height: 2px;
      background-color: var(--primary-color);
      transition: all .4s;
  }
  .focus.form-auto-complete:before {
      left: 0;
      width: 100%;
  }
  .error.form-auto-complete:before {
      left: 50%;
      width: 0;
  }
  .form-auto-complete .input-label {
      position: absolute;
      top: calc(50% + 10px);
      transform: translateY(-50%);
      font-size: 15px;
      color: var(--lighten-5-color);
      z-index: 1;
      transition: all .2s;
  }
  .form-auto-complete .input-label.active {
      top: 6px;
      transform: translateY(0);
      font-size: 13px;
      font-weight: 300;
  }
  .form-auto-complete.focus .input-label {
      top: 6px;
      transform: translateY(0);
      font-size: 13px;
      font-weight: 300;
      color: var(--primary-color);
  }
  .form-auto-complete .error-text {
      position: absolute;
      left: 0;
      top: calc(100% + 3px);
      color: red;
      font-size: 12px;
  }
  .form-auto-complete .list {
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
      background-color: var(--white-color);
      border-radius: 0 3px 3px 0;
      box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
      z-index: 10;
      max-height: 200px;
      overflow: auto;
  }
  .form-auto-complete .item {
      font-size: 15px;
      color: #333;
      padding: 10px 12px;
      transition: all .2s;
      cursor: pointer;
  }
  .form-auto-complete .item.hover,
  .form-auto-complete .item:hover {
      background-color: var(--lighten-1-color)
  }
</style>
